import { useState } from 'react'
import dataSelectField from '@templates/AddNewItemModal/templates/dataSelectField'
import { useGetDangerWorkPlacesQuery } from '@services/dangerWorkPlaces'
import { UseDangerField } from '@app-types/riskMapFields'

const useDangerWorkPlacesField: UseDangerField = ({
  params,
  onOneItem,
  skip,
  initFilters,
}) => {
  const [filters, setFilters] = useState(initFilters)

  return {
    setFilters,
    field: (fieldParams) =>
      dataSelectField({
        query: useGetDangerWorkPlacesQuery,
        filters,
        setFilters,
        dropdownWidth: 500,
        label: 'Работы / Место / Авария',
        name: 'work',
        withManualEntryText: true,
        withShowLabelInDescription: true,
        onOneItem,
        skip,
        ...params,
        ...fieldParams,
      }),
  }
}

export default useDangerWorkPlacesField
